let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("04Ubp")).then(() => parcelRequire('3PgBQ'));